import { BaseModel } from "sjs-base-model";

// post model
export default class ActivityTypePostModel extends BaseModel {
  status = "";
  data = {};
  id = "";

  constructor(data1) {
    super();

    this.update(data1);
  }
}
